import {
  CategoryNameSchemasType,
  filterOption,
  FormInput,
  FormSelect,
  ISODate,
  Tooltip,
} from '@atlas-frontend/sdk';
import React, { useMemo } from 'react';
import { DefaultOptionType } from 'rc-select/lib/Select';
import { isDateBetween } from './utils';

export interface InputDataDimensionFieldProps {
  name: string;
  labels?: CategoryNameSchemasType | null;
  valueDate?: string;
}

interface InputDataClassifierSelectProps {
  name: string;
  options: DefaultOptionType[];
}

export function InputDataDimensionField({
  labels,
  name,
  valueDate,
}: InputDataDimensionFieldProps) {
  const { isClassifier, options } = useMemo(() => {
    let isClassifier = false;
    let options: DefaultOptionType[] = [];
    if (labels) {
      isClassifier = true;
      options = Object.values(labels)
        .filter(
          (label) =>
            !valueDate ||
            isDateBetween(valueDate as ISODate, label.validFrom, label.validTo)
        )
        .map((label) => ({
          label: `${label.code} - ${label.name}`,
          value: label.code,
        }))
        .toSorted((a, b) => a.label.localeCompare(b.label));
    }

    return { isClassifier, options };
  }, [labels, valueDate]);

  if (isClassifier) {
    return <InputDataClassifierSelect name={name} options={options} />;
  }

  return <FormInput size="small" name={name} autoFocus />;
}

function InputDataClassifierSelect({
  name,
  options,
}: InputDataClassifierSelectProps) {
  return (
    <FormSelect
      allowClear={true}
      autoFocus
      className="category-select"
      size="small"
      defaultOpen
      filterOption={filterOption}
      labelRender={(props) => (
        <Tooltip title={props.label}>{props.value}</Tooltip>
      )}
      name={name}
      options={options}
      showSearch
    />
  );
}
